import { InfoIcon } from 'lucide-react';

import { Inline } from '@/ux-common/components/inline/inline';

export const ModeNotice = () => {
  return (
    <Inline className="inline-row-xs">
      <InfoIcon className="glyph glyph-sm stroke-ckds-neutral-500" aria-hidden="true" />
      <span className="text-sm">
        This evaporator’s Defrost Mode setting must be set to Auto_Schedule in order for schedule
        changes to take effect.
      </span>
    </Inline>
  );
};
